import { useEffect, useState } from 'react'
import { Block } from 'baseui/block';
import { Input } from "baseui/input";
import {  ParagraphXSmall } from 'baseui/typography';
import { TP_Building, BuildingType } from './types'
import { FormControl } from "baseui/form-control";
import { Select, Value } from "baseui/select";
import { useSetObjectValue } from '../../../../hooks/useSetObjectValue';
import { GroupSelection } from '../../GroupSelection';
import { FormattedMessage } from 'react-intl';
import { Checkbox, STYLE_TYPE } from 'baseui/checkbox';
import { GoogleMap } from '../../../../components/Map';
import { Tab, Tabs } from 'baseui/tabs-motion';
import { EditAddressForm } from '../../../Spaces/Address';
import { Button } from 'baseui/button';
import { MdOutlineMyLocation } from 'react-icons/md';
import { useStyletron } from 'baseui';
import { useGetCurrentLocation } from '../../../../hooks/useGetCurrentLocation';
import { CurrencySelector } from '../../../../components/CurrencySelector';
import { EditableEnergyRatesList } from '../../../Energy/EnergyRates';
import { LiaAddressCard, LiaFileInvoiceDollarSolid } from 'react-icons/lia';
import { PiMapPinLine } from "react-icons/pi";


export const ConfigurationPanel = (props: TP_Building) => {
    const [activeKey, setActiveKey] = useState<any>("0");

    const [squereMeter, setSquereMeter, setSquereMeterResult] = useSetObjectValue(props.id, props.resourceGroupId, "squereMeter", props.squereMeter);
    const onSquereMeterChanged = (e: any) => setSquereMeter(parseFloat(e.target.value));

    // building type
    const [buildingType, setBuildingType] = useSetObjectValue(props.id, props.resourceGroupId, "buildingType", props.buildingType,0);
    const [bType, setBType] = useState<Value>([{ id: buildingType, label: <FormattedMessage id={`BuildingType.${BuildingType[buildingType]}`} defaultMessage={`${BuildingType[buildingType]}`} /> }]);
    const onBuildingTypeChanged = (e: any) => {
        setBType(e.value);
        setBuildingType(e.value[0].id)
    }
    const types = Object.keys(BuildingType).filter((item) => {
        return isNaN(Number(item));
    });
    const b2 = types.map((item: any, index: number) => { return { label: <FormattedMessage id={`BuildingType.${item}`} defaultMessage={`${item}`} />, id: index } });


    const [showGroupInOP, setShowGroupInOP] = useSetObjectValue(props.id, props.resourceGroupId, "showGroupInOP", props.showGroupInOP,0);
    const [showGroup, setShowGroup] = useState<Value>([{ id: showGroupInOP, label: <FormattedMessage id={`GroupSelection.${GroupSelection[showGroupInOP]}`} defaultMessage={`${GroupSelection[showGroupInOP]}`} /> }]);
    const onShowGroupInOPChanged = (e: any) => {
        setShowGroup(e.value);
        setShowGroupInOP(e.value[0].id);
    }
    const groups = Object.keys(GroupSelection).filter((item) => {
        return isNaN(Number(item));
    });
    const b3 = groups.map((item: any, index: number) => { return { label: <FormattedMessage id={`GroupSelection.${item}`} defaultMessage={`${item}`} />, id: item } });


    const [currencyCode, setCurrencyCode] = useSetObjectValue(props.id, props.resourceGroupId, "currencyCode", props.currencyCode,100);
    const currentCurrency = currencyCode// ?? 'EUR';
    const handleCurrencyChanged = (e: string) => { setCurrencyCode(e) }

    return (
        <>
            <Tabs
                activeKey={activeKey}
                onChange={({ activeKey }) => {
                    setActiveKey(activeKey);
                }}
                activateOnFocus
            >
                <Tab title={<FormattedMessage id="P_Building.Basic" defaultMessage="Basic" />}>
                    <>
                        <FormControl
                            label={() => <FormattedMessage id="P_Building.BuildingType" defaultMessage="Building Type" />}
                            caption={() => <FormattedMessage id="P_Building.EnterBuildingType" defaultMessage="Enter the type of the building" />}
                        >
                            <Select
                                options={b2}
                                value={bType}
                                required
                                searchable={false}
                                labelKey="label"
                                valueKey="id"
                                clearable={false}
                                onChange={onBuildingTypeChanged}
                            />
                        </FormControl>

                        <FormControl
                            label={() => <FormattedMessage id="P_Building.TotalSpace" defaultMessage="Total Space" />}
                            caption={() => <FormattedMessage id="P_Building.EnterTotalSpace" defaultMessage="Enter the total netto space of the building" />}
                        >
                            <Input
                                value={squereMeter}
                                onChange={onSquereMeterChanged}
                                endEnhancer="m²"
                                type='numeric'
                                disabled={setSquereMeterResult.isLoading}
                                error={setSquereMeterResult.isError}
                            />
                        </FormControl>

                        <FormControl
                            label={() => <FormattedMessage id="EnergyOverview.Currency" defaultMessage="Currency" />}
                            caption={() => <FormattedMessage id="EnergyOverview.CurrencyDescr" defaultMessage="Select the currency to be used" />}
                        >
                            <CurrencySelector currencyCode={currentCurrency} onCurrencyCodeChanged={handleCurrencyChanged}></CurrencySelector>

                        </FormControl>
                        <FormControl
                            label={() => <FormattedMessage id="P_Building.DefaultView" defaultMessage="Default View" />}
                            caption={() => <FormattedMessage id="P_Building.EnterDefaultView" defaultMessage="Enter the Default View for the Operator Panel" />}
                        >
                            <Select
                                options={b3}
                                value={showGroup}
                                required
                                clearable={false}
                                searchable={false}
                                labelKey="label"
                                valueKey="id"
                                onChange={onShowGroupInOPChanged}
                            />

                        </FormControl>
                    </></Tab>
                <Tab artwork={() => <LiaFileInvoiceDollarSolid></LiaFileInvoiceDollarSolid>} title={<FormattedMessage id="P_Building.energyRates" defaultMessage="Energy Rates" />}><EditableEnergyRatesList canAddItems {...props}></EditableEnergyRatesList></Tab>
                <Tab artwork={() => <PiMapPinLine />} title={<FormattedMessage id="P_Building.location" defaultMessage="Location" />}> <LocationView {...props} /></Tab>
                <Tab artwork={()=> <LiaAddressCard />} title={<FormattedMessage id="P_Building.address" defaultMessage="Address" />}><EditAddressForm {...props.address} objectId={props.id} resourceGroupId={props.resourceGroupId} ></EditAddressForm></Tab>
            </Tabs>

        </>
    )
}


const LocationView = (props: TP_Building) => {
    const [css, theme] = useStyletron()

    const [latitude, setLatitude, setLatitudeResult] = useSetObjectValue(props.id, props.resourceGroupId, "Address/Latitude", props.address.latitude, 1000);
    const [longitude, setLongitude, setLongitudeResult] = useSetObjectValue(props.id, props.resourceGroupId, "Address/Longitude", props.address.longitude, 1000);
    const [showLocation, setShowLocation, setShowLocationResult] = useSetObjectValue(props.id, props.resourceGroupId, "showLocation", props.showLocation, 10)
    const { data, fetch: fetchLocation, isSuccess, isLoading } = useGetCurrentLocation();

    useEffect(() => {
        if (isSuccess) {
            setLatitude(data.latitude);
            setLongitude(data.longitude);
        }
    }, [isSuccess]);


    return (
        <>
            <FormControl >
                <Checkbox
                    checked={showLocation}
                    checkmarkType={STYLE_TYPE.toggle_round}
                    onChange={(e: any) => { setShowLocation(e.target.checked) }}>
                    <FormattedMessage id="P_Building.ShowLocation" defaultMessage="Show Location" />
                </Checkbox>
            </FormControl>
            {props.showLocation &&
                <>

                    <GoogleMap markers={[{ title: props.description, latitude: props.address.latitude, longitude: props.address.longitude }]}   ></GoogleMap>

                    <FormControl label={<FormattedMessage id="P_Building.Latitude" defaultMessage="Latitude" />}>
                        <Input
                            value={latitude}
                            onChange={(e) => setLatitude(parseFloat(e.target.value))}
                            endEnhancer="°"
                            type='numeric'
                            disabled={setLatitudeResult.isLoading}
                            error={setLatitudeResult.isError}
                        />
                    </FormControl>
                    <FormControl label={<FormattedMessage id="P_Building.Longitude" defaultMessage="Longitude" />}>
                        <Input
                            value={longitude}
                            onChange={(e) => setLongitude(parseFloat(e.target.value))}
                            endEnhancer="°"
                            type='numeric'
                            disabled={setLongitudeResult.isLoading}
                            error={setLongitudeResult.isError}
                        />
                    </FormControl>
                    <Block display={'flex'} flexDirection={'column'}>
                        <Button isLoading={isLoading} onClick={fetchLocation} startEnhancer={() => <MdOutlineMyLocation></MdOutlineMyLocation>}>
                            <FormattedMessage id="P_Building.UseCurrentLocation" defaultMessage="Use my current location" />
                        </Button>
                        <ParagraphXSmall maxWidth={'300px'} color={theme.colors.contentTertiary}>You might need to allow Apps to access your location on Windows under Privacy Settings</ParagraphXSmall>
                    </Block>
                </>
            }
        </>
    )
}


